import React from 'react';

export default function StepperModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full h-full p-5 relative">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-lg font-bold bg-red-500 text-white px-3 py-1 rounded"
          onClick={onClose}
        >
          ✖
        </button>

        {/* Stepper Project Embedded as an iframe */}
        <iframe
          src={`${window.location.origin}/stepper/index.html`}
          className="w-full h-full border-none"
          title="Stepper"
        />
      </div>
    </div>
  );
}
